import { setDisplayErrorSnackBar } from "../../features/userSlice";
import { trackingAnalyticsService } from "../../services/api/tracking-analytics.endpoints";
import store from "../../store";

export const postAnalyticsTracking = async (
  data: any,
  oauthTokenHeader: string
) => {
  try {
    /// send to get data with targetVsActualPRId
    trackingAnalyticsService.postAnalyticsTracking(data, oauthTokenHeader);
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
};
